import { env } from "@roman/shared/config/env";

export const createMarketShareUrl = (marketId: string) => {
  // Use URL constructor to properly handle trailing slashes
  const url = new URL(`/prediction-market/share/${marketId}`, env.API_URL);
  return url.toString();
};
